export default function Imprint() {
    const TitlePart = ({ children }) => {
      return <h1 className="imprint-title">{children}</h1>;
    };
    const ContentPart = ({ children }) => {
      return <p className="aboutUs-content">{children}</p>;
    };
    const Link = ({href, name}) => {
    return <a className="imprint-link" href={href} target="_blank" rel="noopener">{name}</a>
    }
    const PartContainer = ({ children }) => {
      return <div className="aboutUs-part-container">{children}</div>;
    };
    return (
      <div className="mb-32">
        <PartContainer>
          <TitlePart>{"PUBLICATION"}</TitlePart>
          <ContentPart>
              {`Ce site web est la propriété de Canal 32, 7 rue Raymond Aron, 10120 Saint-André-Les-Vergers, 
              France. Le directeur de la publication est Fabrice Schlosser, directeur de Canal 32.`}
          </ContentPart>
          <ContentPart>
              {`Ce site est hébergé par `}
              <Link href={"https://www.ovh.com/fr/"} name="OVH"/>
              {`, 2 rue Kellermann, 59100 Roubaix, France.`}
          </ContentPart>
          </PartContainer>
          <PartContainer>
          <TitlePart>{"DONNÉES PERSONNELLES"}</TitlePart>
          <ContentPart>
              {`Canal 32 ne recueillera vos données personnelles qu'uniquement lors de l'envoi
            d'une info ou d'une question dans le cadre de l'utilisation du service "Poser une question" et "Envoyer une info".`}
          </ContentPart>
          <ContentPart>
              {`Un cookie anonyme et inoffensif peut toutefois être stocké sur votre ordinateur 
              ou votre smartphone lorsque vous utilisez la version mobile du site. Pour plus d'informations, vous pouvez lire cet article :`}
          </ContentPart>
          <ContentPart>
              <Link href={"https://fr.wikipedia.org/wiki/Cookie_%28informatique%29"} name="Cookie (Informatique)"/>
          </ContentPart>
          </PartContainer>
          <PartContainer>
          <TitlePart>{"PROGRAMME PUBLICITAIRE"}</TitlePart>
          <ContentPart>
              {`Google et ses fournisseurs tiers utilisent un cookie pour afficher des 
              annonces pertinentes en fonction de votre navigation sur ce site et d'autres sites. Vous pouvez désactiver ce cookie en vous rendant sur cette page : `}
              <Link href={"https://policies.google.com/technologies/ads"} name="https://policies.google.com/technologies/ads"/>
          </ContentPart>
          </PartContainer>
          <PartContainer>
          <TitlePart>{"PROPRIÉTÉ INTELLECTUELLE"}</TitlePart>
          <ContentPart>
              {`L'ensemble de ce site relève de la législation française et 
              internationale sur le droit d'auteur et la propriété intellectuelle. 
              Tous les droits de reproduction sont réservés. La reproduction de tout 
              ou partie de ce site sur un support électronique quel qu'il soit est 
              formellement interdite sauf autorisation expresse du directeur de la 
              publication. Le non-respect de cette interdiction constituerait une 
              contrefaçon sanctionnée par le Code de la propriété intellectuelle.`}
          </ContentPart>
          </PartContainer>
      </div>
    );
  }
  